import styles from "src/components/organisms/Footer/styles.module.css";
import LogoT from "src/assets/icons/T.svg";
import { useRedirect } from "src/navigation/useRedirect";
import { PAGES } from "src/types/navigation";
import { getSupportUrl } from "src/api/user/profile";
import { SocialLinks } from "src/components/molecules/SocialLinks";
import { Msg } from "src/i18n/Msg";

export const Footer: React.FC = () => {
  const { redirect } = useRedirect();

  const handleClick = (scheme: PAGES) => redirect({ scheme });

  const handleSupportClick = async () => {
    const supportUrl = await getSupportUrl();

    if (supportUrl) {
      window.location.href = supportUrl;
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.leftSection}>
        <div className={styles.logoSection}>
          <img src={LogoT} alt="T Logo" className={styles.logoT} />
        </div>
        <div className={styles.legalLinks}>
          <p
            className={styles.link}
            onClick={() => handleClick(PAGES.TERMS)}
            role="button"
          >
            <Msg id="components.organisms.Footer.terms" />
          </p>
          <span className={styles.link}>|</span>
          <p className={styles.link} onClick={handleSupportClick} role="button">
            <Msg id="components.organisms.Footer.policy" />
          </p>
        </div>
      </div>

      <SocialLinks className={styles.socialIcons} />
    </footer>
  );
};
